import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A workspace saved size was created',
  name: 'saved_size_created',
  params: [
    {
      description: 'Where the size was saved from',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['canvas_picker', 'crop', 'context'],
    },
    {
      description: 'The id of the saved size',
      name: 'size_preset_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The saved size width in pixels',
      name: 'width',
      required: true,
      type: 'number',
    },
    {
      description: 'The saved size height in pixels',
      name: 'height',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
